<template>
  <section
    :class="['w-100', 'header-navbar', isLogin ? 'login-header' : '']"
    id="navbar"
  >
    <div class="container header-container">
      <div class="row">
        <div class="col-8 col-sm-8 col-lg-4 logo-row">
          <div
            style="width:fit-content; cursor: pointer"
            class="icon-section"
            :class="isInvitation ? 'logo-invitation' : 'logo'"
            @click="logoClicked"
          >
            <img
              class="logo_img"
              src="/static/img/landing/xeropan-long-logo.svg"
              alt="Xeropan logo"
            />
          </div>
        </div>
        <div
          class="col-4 col-sm-4 col-lg-8 px-0 px-sm-0 px-lg d-flex justify-content-end navbar-col"
        >
          <nav
            class="navbar navbar-expand-lg navbar-light p-0 d-flex justify-content-end"
          >
            <button
              v-if="!isLogin"
              class="navbar-toggler border-0"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              @click="openSettings"
            >
              <span
                :class="
                  isInvitation
                    ? 'navbar-toggler-icon-invitation'
                    : 'navbar-toggler-icon'
                "
              ></span>
            </button>
            <div
              v-if="!isLogin"
              :class="
                hasToken
                  ? 'collapse navbar-collapse logged-in'
                  : 'collapse navbar-collapse'
              "
              id="navbarNav"
            >
              <ul class="navbar-nav">
                <li
                  v-show="!hasToken"
                  :class="
                    isInvitation ? 'nav-item' : 'nav-item nav-item-functions'
                  "
                >
                  <a class="nav-link" href="/practice/">{{
                    $t("app.landing.navbar.functions")
                  }}</a>
                </li>
                <li
                  v-show="!hasToken"
                  :class="
                    isInvitation ? 'nav-item' : 'nav-item nav-item-about-us'
                  "
                >
                  <a class="nav-link" @click="scrollToSection('#about-us')">{{
                    $t("app.landing.navbar.aboutUs")
                  }}</a>
                </li>
                <li
                  v-show="!hasToken"
                  :class="
                    isInvitation ? 'nav-item' : 'nav-item nav-item-premium'
                  "
                >
                  <a class="nav-link" href="/pricing/">{{
                    $t("app.landing.navbar.premium")
                  }}</a>
                </li>
                <li
                  v-show="!hasToken"
                  :class="
                    isInvitation ? 'nav-item' : 'nav-item nav-item-download'
                  "
                >
                  <a class="nav-link" href="/download/">{{
                    $t("app.landing.navbar.download")
                  }}</a>
                </li>
                <li
                  v-if="!hasToken"
                  :class="isInvitation ? 'nav-item' : 'nav-item'"
                >
                  <!-- <a
                    :href="loginHref"
                    class="nav-link login btn"
                    @click="openLogin"
                  >{{$t("app.landing.navbar.login")}}</a> -->
                  <router-link
                    class="nav-link login btn"
                    :to="loginHref"
                    @click.native="openLogin"
                  >
                    {{ $t("app.landing.navbar.login") }}
                  </router-link>
                </li>
                <li v-else-if="hasToken && finishedOnboarding" class="nav-item">
                  <a href="/" class="nav-link start btn">{{
                    $t("app.landing.navbar.continueLearnings")
                  }}</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavBar',
  components: {},
  data() {
    return {
      loginHref: '',
      isInvitation: false,
      hasToken: undefined,
      finishedOnboarding: undefined,
    };
  },
  computed: {
    ...mapGetters({
      getUserSettings: 'settings/getUserSettings',
    }),
    isLogin() {
      return (
        this.$route.name === 'AuthenticationScreen' ||
        this.$route.name === 'OnboardingScreen'
      );
    },
  },
  async created() {
    if (
      this.$store.getters.getAuthToken !== undefined &&
      this.$store.getters.getAuthToken !== null &&
      this.$store.getters.getAuthToken !== '' &&
      this.$store.getters.getAuthToken !== ' '
    ) {
      this.hasToken = true;
    }

    this.loginHref = '/login';
    if (this.$route.name === 'InvitationScreen') {
      this.isInvitation = true;
    }
    this.finishedOnboarding = this.getUserSettings('finishedOnboarding');
  },
  methods: {
    logoClicked() {
      location.href = '/';
    },
    scrollToSection(section) {
      setTimeout(() => {
        document.querySelector(section).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 500);
    },
    openLogin() {
      // gtag measurement point
      if (this.$gtag) {
        this.$gtag.event('Start opening', {
          event_category: 'Button',
          event_label: 'START_OPENING',
        });
      }
      if (this.hasToken) {
        this.$router.push('/');
      } else {
        this.$router.push('/login/');
      }
    },
    executeHidden() {
      this.$emit('hidden');
    },
    openSettings() {
      this.$emit('openSettings');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/landing/main.scss";
@import "~bootstrap/scss/mixins/";
@import "~bootstrap/scss/_nav";
@import "~bootstrap/scss/_navbar";
@import "~bootstrap/scss/_transitions.scss";

.arrowClass {
  display: none;
}
.header-container {
  @media (min-width: 1280px) and (max-width: 1919px) {
    .navbar-col {
      padding-right: 6% !important;
    }
  }
}
.login-header {
  position: absolute;
  background: white;
  padding: 9px 0 !important;
  box-shadow: 0 2px 8px 0 rgba(12, 18, 31, 0.16);
  z-index: 1 !important;
}
#navbar {
  z-index: 10001;
  padding: 24px 0 20px 0;
  @media (min-width: 1280px) and (max-width: 1919px) {
    padding: 34px 0 20px 0;
  }

  @include media-breakpoint-down(md) {
    padding: 11px 0;
  }

  .logged-in {
    justify-content: flex-end;
  }

  a.logo {
    &:hover {
      text-decoration: none;
    }
    .logo-title {
      vertical-align: middle;

      vertical-align: middle;
      font-family: Baloo, cursive;
      color: var(--primaryBlue);
      font-weight: normal;
      padding: 0 0 0 17px;
      font-size: 36px;
      letter-spacing: -2.3px;

      @media (min-width: 992px) and (max-width: 1021px) {
        font-size: 22px;
      }

      @media (max-width: 1919px) {
        font-size: 26px;
        padding: 0px 0 0 12px;
      }

      @include media-breakpoint-down(md) {
        font-size: 23px;
        letter-spacing: -0.5px;
      }

      @media (min-width: 992px) {
        color: var(--primaryBlue);
      }
    }

    &:hover {
      text-decoration: none;
    }
  }
  .icon-section {
    .logo_img {
      height: 41.8px;
    }
    @media (max-width: 1919px) {
      .logo_img {
        height: 30.9px;
      }
    }
  }
  a.logo-invitation {
    .logo-title {
      vertical-align: middle;

      font-family: Baloo, cursive;
      font-size: 24px;
      color: var(--primaryBlue);
      padding: 0 0 0 10px;
      font-weight: normal;

      @media (min-width: 992px) and (max-width: 1021px) {
        font-size: 22px;
      }

      @include media-breakpoint-down(md) {
        font-size: 20px;
      }

      @include media-breakpoint-only(xs) {
        // color: var(--white);
        font-size: 20px;
      }
    }

    &:hover {
      text-decoration: none;
    }
  }

  .navbar {
    @include media-breakpoint-down(md) {
      text-align: center;
    }
    li.nav-item-about-us,
    li.nav-item-premium,
    li.nav-item-download {
      padding-left: 1.1rem !important;
      @media (min-width: 1280px) and (max-width: 1919px) {
        padding-left: 0.45rem !important;
      }
    }

    li.nav-item {
      display: flex;
      align-items: center;
      padding-right: 5px;
      padding-left: 1.6rem;
      @media (min-width: 1280px) and (max-width: 1919px) {
        padding-left: 1.1rem;
      }

      a.nav-link {
        cursor: pointer;
        font-family: Roboto;
        font-size: 19px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: left;
        color: var(--terraGrey);

        @media (max-width: 1919px) {
          font-size: 13px;
        }
        &:hover {
          text-decoration: none;
          color: #389de2;
        }

        @include media-breakpoint-down(lg) {
          font-size: 16px !important;
        }
      }

      a.login,
      a.start {
        min-width: 114px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
        padding: 5px 15px !important;

        @media (max-width: 1919px) {
          font-size: 11px;
          padding: 11.5px 15px !important;
          height: 19px;
          min-width: 81px;
        }

        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: center;
        color: var(--primaryBlue);
        background-color: var(--white);
        border-radius: 26px;
        border: 2px solid var(--primaryBlue);
        transition: 1s all cubic-bezier(0.19, 1, 0.22, 1);

        @include media-breakpoint-down(md) {
          padding: 0;
          border: unset !important;
          color: $header-navbar-menu-item-color !important;
          background-color: unset !important;
        }
      }

      a.login:hover {
        text-decoration: none;
        color: var(--primaryBlue);
        background-color: rgba(72, 176, 247, 0.1);
      }

      a.start {
        color: var(--white);
        background-color: var(--primaryBlue);
        border: none;
        &:hover {
          color: var(--white);
          background-color: #389de2;
        }
      }

      @include media-breakpoint-down(md) {
        padding-right: 0;
      }
    }

    li.nav-item-invitation {
      padding-right: 5px;

      a.nav-link {
        font-family: Roboto;
        font-size: 19px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: left;
        color: var(--terraGrey);

        &:hover {
          text-decoration: underline;
        }

        @include media-breakpoint-down(lg) {
          font-size: 16px !important;
        }
      }

      a.start {
        background-color: var(--primaryBlue) !important;
        border: none !important;
        &:hover {
          background-color: #389de2;
        }
      }

      a.login,
      a.start {
        cursor: pointer;
        padding: 5px 15px !important;

        &:hover {
          text-decoration: none;
        }

        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: center;
        color: var(--primaryBlue);
        background-color: var(--white);
        border-radius: 26px;
        border: 2px solid var(--primaryBlue);
        transition: 1s all cubic-bezier(0.19, 1, 0.22, 1);

        @include media-breakpoint-down(md) {
          padding: 0;
          border: unset !important;
          color: $header-navbar-menu-item-color !important;
          background-color: unset !important;
        }
      }

      a.login:hover {
        text-decoration: none;
        background-color: rgba(72, 176, 247, 0.1);
      }

      @include media-breakpoint-down(md) {
        padding-right: 0;
      }
    }

    .navbar-toggler-icon {
      background-image: url("/static/img/landing/hamburger_menu.svg");
      height: 12px;
    }

    .navbar-toggler-icon-invitation {
      display: inline-block;
      width: 1.5em;
      height: 1.5em;
      vertical-align: middle;
      content: "";
      background: no-repeat center center;
      background-size: 100% 100%;
      background-image: url("/static/img/landing/hamburger_menu.svg");
      height: 12px;
    }

    .navbar-toggler:focus {
      outline: none;
    }
  }
}
// .logo,
// .logo-invitation {
//   img {
//     width: 41.8px;
//     height: 41.8px;

//     @media (max-width: 1919px) {
//       width: 30.9px;
//       height: 30.9px;
//     }
//   }
// }
</style>

<style>
.popover-inner-class {
  background: white;
}
</style>
